<!-- Games Search Bar -->
<div class="home_games--search" [ngClass]="isOnClickSearch ? 'show-Search':'hide-Search'" id="searchgames">
    <app-slot-games-search></app-slot-games-search>
</div>